module.exports = __webpack_public_path__ + "static/ios-22966ffc35bf87db4509b7b25bc58458.jpg";